import { Box, Skeleton } from '@mui/material';

export function LoadingSkeleton({ rows = 6, height = 40 }: { rows?: number; height?: number }) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, p: 1 }}>
      {Array.from({ length: rows }).map((_, i) => (
        <Skeleton key={i} variant="rounded" height={height} animation="wave" />
      ))}
    </Box>
  );
}
